import { NetworkConfig } from "src/network/NetworkConfig";
import styles from "./BrandLogo.module.css";

export const BrandLogo = () => {
    const customerName = getComputedStyle(document.documentElement).getPropertyValue("--wwcustomername");
    return (
        <div>
            <img className={styles.BrandLogo} src={NetworkConfig.brandAssets.logoImage} alt={customerName} />
        </div>
    );
};
